import SentryAdapter from './adapters/Sentry';
import ElasticAdapter from './adapters/Elastic';

class ErrorLogger {
  constructor(
    adapters = [
      new SentryAdapter(),
      new ElasticAdapter(),
    ]
  ) {
    this.adapters = adapters;
  }

  init() {
    this.adapters.forEach((logger) => {
      logger.init();
    });
  }

  captureException(transactionName, severityLevel, error, details) {
    this.adapters.forEach((logger) => {
      logger.captureException(transactionName, severityLevel, error, details);
    });
  }

  captureLog(transactionName, severityLevel, details) {
    this.adapters.forEach((logger) => {
      logger.captureLog(transactionName, severityLevel, details);
    });
  }

  captureUIException(error, { componentStack }) {
    this.adapters.forEach((logger) => {
      logger.captureUIException(error, { componentStack });
    });
  }
}

export default new ErrorLogger();



// WEBPACK FOOTER //
// ./src/utils/errorLogger/index.js